import { SelectOptionTypes } from "../../../../components/Input";
import { InstrumentSummary } from "../../../../services/instruments";
import { COUNTRY_OPTIONS } from "../../../../utils";

export const FORM_ID = "source-country-form";

export const SOURCE_COUNTRY_HELPER =
  "The country this instrument's dividends are declared under on a tax return. It applies to every holder of this instrument.";

// An empty value, not a missing option, so clearing the country is an explicit choice the select can show.
export const NOT_SET_OPTION: SelectOptionTypes = {
  value: "",
  label: "Not set",
};

export const SOURCE_COUNTRY_OPTIONS: SelectOptionTypes[] = [
  NOT_SET_OPTION,
  ...COUNTRY_OPTIONS,
];

export const countryOptionFor = (
  sourceCountry: string | null,
): SelectOptionTypes =>
  SOURCE_COUNTRY_OPTIONS.find((option) => option.value === sourceCountry) ??
  NOT_SET_OPTION;

export const instrumentLabelOf = (instrument: InstrumentSummary): string =>
  `${instrument.symbol} · ${instrument.name}`;
